import isEmpty from './isEmpty'

export function getImageType(path: string) {
  const fileExtension = path.match(/.[a-z]+$/i)?.[0]?.slice(1)

  if (isEmpty(fileExtension)) {
    return ''
  }

  return `image/${fileExtension}`
}
